/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import OverlayService from "./overlay-service.es6.js";
var DESKTOP_BREAKPOINT = 1023;
var WindowResizeHandler = function () {
  function WindowResizeHandler() {
    _classCallCheck(this, WindowResizeHandler);
    this.desktopNavWrapper = document.querySelector('#desktop-primary-nav');
    this.mobileNavWrapperId = document.querySelector('#mobile-primary-nav');
    this.accountButton = document.querySelector('.account-button-wrapper');
    this.accountWrapperId = document.querySelector('#account-nav');
    this.tabTitleWrapper = document.querySelector('.types-of-care--tab-titles-wrapper');
    this.desktopNavButtons = this.desktopNavWrapper.querySelectorAll('.item-title-wrapper');
    this.globalSearchDropdownDivs = document.querySelectorAll('.global-search-dropdown');
    this.wasSetToMobile = WindowResizeHandler.isCurrentlyMobile();
  }
  return _createClass(WindowResizeHandler, [{
    key: "setTabTitlePosition",
    value: function setTabTitlePosition() {
      if (window.innerWidth >= this.tabTitleWrapper.scrollWidth) {
        this.tabTitleWrapper.style.justifyContent = 'center';
      } else {
        this.tabTitleWrapper.style.justifyContent = 'unset';
      }
    }
  }, {
    key: "closeActivePrimaryMenu",
    value: function closeActivePrimaryMenu() {
      var activeDesktop = this.desktopNavWrapper.querySelectorAll('.active');
      activeDesktop.forEach(function (activeEl) {
        activeEl.classList.remove('active');
      });
      this.mobileNavWrapperId.classList.remove('active');
      var activeMobile = this.mobileNavWrapperId.querySelectorAll('.active');
      activeMobile.forEach(function (activeEl) {
        activeEl.classList.remove('active');
      });
    }
  }, {
    key: "closeAllActiveMenus",
    value: function closeAllActiveMenus() {
      this.closeActivePrimaryMenu();
      this.accountButton.classList.remove('active');
      var activeAccountMenus = this.accountWrapperId.querySelectorAll('.active');
      activeAccountMenus.forEach(function (activeEl) {
        activeEl.classList.remove('active');
      });
      this.closeGlobalSearchDropdown();
    }
  }, {
    key: "closeGlobalSearchDropdown",
    value: function closeGlobalSearchDropdown() {
      if (this.globalSearchDropdownDivs.length > 0) {
        this.globalSearchDropdownDivs.forEach(function (div) {
          div.classList.remove('active');
        });
      }
    }
  }, {
    key: "windowChangedToDesktopOrMobile",
    value: function windowChangedToDesktopOrMobile() {
      if (this.wasSetToMobile && WindowResizeHandler.isCurrentlyMobile() || !this.wasSetToMobile && !WindowResizeHandler.isCurrentlyMobile()) {
        return false;
      }
      if (this.wasSetToMobile && !WindowResizeHandler.isCurrentlyMobile()) {
        this.wasSetToMobile = false;
        return true;
      }
      if (!this.wasSetToMobile && WindowResizeHandler.isCurrentlyMobile()) {
        this.wasSetToMobile = true;
        return true;
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      if (this.windowChangedToDesktopOrMobile()) {
        this.closeAllActiveMenus();
        this.overlayService.toggleOverlay(false);
        if (this.tabTitleWrapper) {
          this.setTabTitlePosition();
        }
      }
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this = this;
      window.addEventListener('resize', function () {
        _this.handleWindowResize();
      });
      window.addEventListener('load', function () {
        _this.overlayService = new OverlayService();
      });
    }
  }], [{
    key: "isCurrentlyMobile",
    value: function isCurrentlyMobile() {
      return window.innerWidth < DESKTOP_BREAKPOINT;
    }
  }]);
}();
export { WindowResizeHandler as default };
(function () {
  var windowResizeHandler = new WindowResizeHandler();
  windowResizeHandler.setListeners();
})(Drupal);